import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import search from "../../media/icons/search.svg";
import arrows from "../../media/icons/arrows.svg";

function booksList({ data }) {
    const [showAll, setShowAll] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchValue2, setSearchValue2] = useState("");
    const [filteredData, setFilteredData] = useState([]); // Nuevo estado para almacenar los resultados de búsqueda
  
    const navigate = useNavigate();
  
    function onSearch(selector) {
      let filter;
      let filtered;
  
      if (selector === "name") {
        filter = searchValue.toUpperCase();
        filtered = data.filter((book) =>
             book.Nombre?.toUpperCase().includes(filter)
        );
      } else if (selector === "autor") {
        filter = searchValue2.toUpperCase();
        filtered = data.filter((book) =>
            book.Autor?.toUpperCase().includes(filter)
        );
      }
  
      setFilteredData(filtered);
      setShowAll(true); // Mostrar todos los resultados filtrados en una sola vista
    }


    function onCategory(name) {
        
          let filter = name.toUpperCase();
          let filtered = data.filter((book) =>
               book.Asignatura?.toUpperCase().includes(filter)
          );
        
    
        setFilteredData(filtered);
        setShowAll(true); // Mostrar todos los resultados filtrados en una sola vista
      
    }
  
    function searchRecovery() {
      setFilteredData([]);
      setSearchValue("");
      setSearchValue2("");
      setShowAll(false);
    }
  
    //!------------------------------------------------------------------
    //PAGINATION
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
  
    const activeData = filteredData.length > 0 ? filteredData : data; // Usar datos filtrados si existen
    const totalPages = Math.ceil(activeData.length / itemsPerPage);
  
    const handleClick = (pageNumber) => {
      setCurrentPage(pageNumber);
      setShowAll(false);
    };
  
    const handleShowAll = () => {
      setShowAll(!showAll);
    };
  
    const handlePrevious = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };
  
    const handleNext = () => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    };
  
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = activeData.slice(indexOfFirstItem, indexOfLastItem);
  
    //----------------------------------------------------------------
  
    return (
      <div className="d-flex flex-column gap-3 mb-5 col-12">

        <div className="creamBackground rounded-4 p-3">
        <div className="my-3">
            <h3 className="regularText text-center pb-3 dark">Categorías comunes </h3>
            <div className="d-flex justify-content-center flex-row flex-wrap gap-2">
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Matemáticas")}>Matemáticas</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Química Orgánica")}>Química Org.</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Química Inorgánica")}>Química Inorg.</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Biología")}>Biología</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Botánica sistemática")}>Botánica sist.</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Física")}>Física</span>
                <span className="militaryBackground rounded-3 text-white p-2" onClick={() => onCategory("Estadística")}>Estadística</span>
            </div>
        </div>
        </div>

        <div className="creamBackground rounded-4 p-3">
          <div className="d-flex flex-row align-items-center">
            <input
              className="form-control form-control-lg"
              value={searchValue2}
              onChange={(e) => setSearchValue2(e.target.value)}
              type="text"
              placeholder="Nombre del autor"
            />
            <button className="brownBtn" onClick={() => onSearch("autor")}>
              <img
                src={search}
                className="whiteImage"
                alt="findImg"
                width="30px"
              />
            </button>
          </div>
        </div>
  
        <div className="creamBackground rounded-4 p-3">
          <div className="d-flex flex-row align-items-center">
            <input
              className="form-control form-control-lg"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              type="text"
              placeholder="Nombre del libro"
            />
            <button className="brownBtn" onClick={() => onSearch("name")}>
              <img
                src={search}
                className="whiteImage"
                alt="findImg"
                width="30px"
              />
            </button>
          </div>
        </div>
  
        <div>
          <button className="brownBtn w-100" onClick={searchRecovery}>
            Reiniciar búsqueda
          </button>
        </div>
  
        {activeData.length > 0 ? (
          <div>
            <table className="table p-3 mt-5" id="mainTable">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="click "
                    onClick={() => sortRows(0, "string")}
                  >
                    Título
                    <img src={arrows} width="10px" alt="sortImg" />
                  </th>
                  <th
                    scope="col"
                    className="click "
                    onClick={() => sortRows(1, "string")}
                  >
                    Autor
                    <img src={arrows} width="10px" alt="sortImg" />
                  </th>
                  <th
                    scope="col"
                    className="click "
                    onClick={() => sortRows(2, "int")}
                  >
                    Año
                    <img src={arrows} width="10px" alt="sortImg" />
                  </th>
                  <th
                    scope="col"
                    className="click "
                    onClick={() => sortRows(3, "string")}
                  >
                    Categoría
                    <img src={arrows} width="10px" alt="sortImg" />
                  </th>
                  <th scope="col" className="click">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody>
                {(showAll ? activeData : currentItems).map((item, i) => {
                  return (
                    <tr key={i}>
                      <td>{item.Nombre}</td>
                      <td>{item.Autor}</td>
                      <td>{item.Año}</td>
                      <td>{item.Asignatura}</td>
                      <td>
                        <span
                          className={
                            item.Estado === true
                              ? ""
                              : "militaryBackground text-white p-1 my-1 rounded-2 regularText"
                          }
                        >
                          {item.Estado === true ? "Disponible" : "Prestado"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
  
            {!showAll && (
              <nav
                aria-label="Page navigation example"
                className="d-flex flex-wrap flex-row align-items-center justify-content-center pt-4 "
              >
                <ul className="pagination d-flex flex-wrap row-gap-1">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="creamBackground dark regularText page-link"
                      onClick={handlePrevious}
                    >
                      Previous
                    </button>
                  </li>
                  {[...Array(totalPages).keys()].map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="creamBackground dark regularText page-link"
                        onClick={() => handleClick(pageNumber + 1)}
                      >
                        {pageNumber + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="creamBackground dark regularText page-link"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            )}
            <button
              onClick={handleShowAll}
              className="btn btn-secondary mt-3 col-12 regularText"
            >
              {showAll ? "MOSTRAR POR PÁGINAS" : "MOSTRAR TODOS"}
            </button>
          </div>
        ) : (
          <h1>No se encontraron resultados</h1>
        )}
      </div>
    );
  }
  

export default booksList;